export default __webpack_public_path__ + "static/media/play.222a0afb.svg";